import { Route } from '@/modules/core/app/constants/api.constants';
import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';
import { Announcement } from '@/modules/announcement/models/Announcement';
import { BaseListService } from '@/modules/core/table/services/BaseListService';

export class AnnouncementListService extends BaseListService {
  getRoute(): Route {
    return Route.ANNOUNCEMENTS;
  }

  getModel(): BaseModel {
    return Announcement;
  }

  addParams(params: Params = {}): Params {
    params.with = [
      'lastEditedByUser',
      'jurisdictions',
      'billingPlanMappings',
      'estateRoles',
      'professions',
      'countries',
      'excludedCompanies'
    ];
    params.sort = '-createdAt';

    return super.addParams(params);
  }
}

export default new AnnouncementListService();
